import { Component, ViewChild } from '@angular/core';
import { ResetService, ProgressBarService,CommonDataService, DataLoaderService } from '../expert-service-call.index';
@Component({
  selector: 'expert-reset',
  templateUrl: './expert-reset.template.html',
  styleUrls: ['./expert-reset.component.css'],
})
export class ExpertReset {
  @ViewChild('expResetModal') expResetModal: any;
  constructor(private resetService: ResetService, private progressBarService: ProgressBarService,
    private dataLoaderService: DataLoaderService,private commonDataService: CommonDataService) {
  }

  resetExpert() {
    this.resetService.resetNormalExpert();
    this.progressBarService.illuminateRed();
    this.dataLoaderService.flagDictionary.expertValidateFlag = false;
    this.dataLoaderService.flagDictionary.expertFlag = false;
    this.dataLoaderService.flagDictionary.expertResetFlag = true;
  }
  closeReset() {
    this.dataLoaderService.flagDictionary.expertResetFlag = true;
  }
}





// WEBPACK FOOTER //
// ./src/app/components/selectable-tabs/expert-screen-components/expert-reset/expert-reset.component.ts